import React, { FC, useEffect } from 'react';
import styled from 'styled-components';

import { Book } from '~/api/book/bookApiTypes';
import { PaperStyle } from '~/atomic/atom/PaperStyle';
import { SCCatalogGrid } from '~/atomic/page/catalog/styled';
import { CSSSkeleton } from '~/atomic/page/index/styled';
import { TextRegStyle } from '~/atomic/Typography';
import { BookCard } from '~/feature/book/BookCard/BookCard';

export interface ContestBooksProps {
  onLoadBooks: () => void;
  books: Book[];
  isLoading: boolean;
  description: string;
}

export const ContestBooks: FC<ContestBooksProps> = ({
  onLoadBooks, books, isLoading, description,
}) => {
  const isShowBooks = (books?.length ?? 0) > 0 && !isLoading;
  const isShowEmpty = !isShowBooks && !isLoading;

  useEffect(() => {
    onLoadBooks();
  }, []);

  return (
    <SCContestBooks>
      <SCDescription>
        {description}
      </SCDescription>
      <SCCatalogGrid>
        {isLoading ? Array(18)
          .fill('dummy')
          .map((dummy, index) => (
            <CSSSkeleton key={index} active />
          )) : null}
        {isShowBooks ? books.map((book) => (
          <BookCard key={book.id} book={book} />
        )) : null}
      </SCCatalogGrid>
      {isShowEmpty
        ? (
          <SCEmptyBooksText>Формируется список участников</SCEmptyBooksText>
        )
        : null}
    </SCContestBooks>
  );
};

const SCContestBooks = styled.div`
  flex-shrink: 1;
`;

const SCDescription = styled.div`
  ${PaperStyle};
  ${TextRegStyle};
  color: var(--black-color);
  padding: 16px 32px;
  margin-bottom: 24px;
`;

const SCEmptyBooksText = styled.span`
  display: flex;
  ${TextRegStyle};
  color: var(--black-color);
  justify-content: center;
  width: 100%;
`;
